import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { ModalData } from '../modal/models/modal-data';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DraggableModalWrapperComponent } from '../modal/draggable-modal-wrapper/draggable-modal-wrapper.component';

@Component({
    selector: 'app-rich-dialog',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        DraggableModalWrapperComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './rich-dialog.component.html',
})
export class RichDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ModalData,
        private dialogRef: MatDialogRef<RichDialogComponent>,
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}
